import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-title" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_6 = { class: "trezo-card-content" }
const _hoisted_7 = { class: "mb-[20px]" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_10 = { class: "mt-2 text-gray-500 dark:text-gray-400" }
const _hoisted_11 = {
  key: 1,
  class: "text-center py-5"
}
const _hoisted_12 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "block mb-[12px] font-semibold text-[17px] text-black dark:text-white" }
const _hoisted_15 = { class: "mt-3" }
const _hoisted_16 = {
  key: 3,
  class: "text-center py-5 text-gray-400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.searchResults.length) + " ", 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.directT('search.resultsFound')), 1),
          _createTextVNode(" \"" + _toDisplayString(_ctx.searchQuery) + "\" ", 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("form", {
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.performSearch && _ctx.performSearch(...args)), ["prevent"])),
          class: "flex"
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
            placeholder: _ctx.directT('common.searchHere'),
            class: "bg-gray-50 border border-gray-50 h-[44px] rounded-l-md w-full block text-black pt-[11px] pb-[12px] px-[13px] md:px-[16px] placeholder:text-gray-500 outline-0 dark:bg-[#15203c] dark:text-white dark:border-[#15203c] dark:placeholder:text-gray-400"
          }, null, 8, _hoisted_8), [
            [_vModelText, _ctx.searchQuery]
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("button", {
            type: "submit",
            class: "bg-primary-500 hover:bg-primary-600 text-white h-[44px] px-4 rounded-r-md transition-all"
          }, [
            _createElementVNode("i", { class: "material-symbols-outlined !text-[20px]" }, " search ")
          ], -1))
        ], 32)
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "inline-block animate-spin rounded-full h-8 w-8 border-4 border-primary-500 border-t-transparent" }, null, -1)),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.directT('search.searching')), 1)
          ]))
        : (_ctx.searchResults.length === 0 && _ctx.searchQuery)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _cache[4] || (_cache[4] = _createElementVNode("i", { class: "material-symbols-outlined !text-[50px] text-gray-400 mb-2" }, "search_off", -1)),
              _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.directT('search.noResults')), 1)
            ]))
          : (_ctx.searchResults.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (result, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "border border-gray-100 dark:border-[#172036] mb-[15px] rounded-md p-[20px]"
                  }, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(result.title), 1),
                    _createElementVNode("p", null, _toDisplayString(result.content), 1),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_router_link, {
                        to: result.link,
                        class: "text-primary-500 hover:underline inline-flex items-center"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.directT('search.viewDetails')) + " ", 1),
                          _cache[5] || (_cache[5] = _createElementVNode("i", { class: "material-symbols-outlined !text-[16px] ml-1" }, "arrow_forward", -1))
                        ]),
                        _: 2,
                        __: [5]
                      }, 1032, ["to"])
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.directT('search.startSearching')), 1))
    ])
  ]))
}